import { useEffect, useState } from "react";
import api from "@/lib/api";

const STORAGE_KEY = "gully_web_session_id";
const SEEN_KEY = "gully_memory_last_seen";

/**
 * Iter XX.47 — Detect if the Memory has changed since the user last
 * opened it. Returns a boolean. Frontend-only — no new backend.
 *
 * Fingerprint is the same one computed inside `/me` `KnowsTab`.
 * When it changes, the primary Chat header shows a subtle dot.
 */
export default function useMemoryHasNew() {
  const [hasNew, setHasNew] = useState(false);
  useEffect(() => {
    let alive = true;
    (async () => {
      let sid;
      try { sid = localStorage.getItem(STORAGE_KEY); } catch { return; }
      if (!sid) return;
      try {
        const r = await api.get("/web/knows", { params: { session_id: sid } });
        if (!alive) return;
        const d = r.data || {};
        const fp = String(
          (d.strengths?.length || 0) * 1
          + (d.patterns?.length || 0) * 3
          + (d.recurring_mistakes?.length || 0) * 5
          + (d.recent_improvements?.length || 0) * 7
          + (d.still_needs_work?.length || 0) * 11
          + (d.stats?.video_reviews || 0) * 13
        );
        let seen;
        try { seen = localStorage.getItem(SEEN_KEY); } catch { seen = null; }
        // Only badge if the user has visited /me at least once AND the
        // count moved. First-visit case shouldn't badge.
        if (seen && seen !== fp) setHasNew(true);
      } catch { /* ignore */ }
    })();
    // Live-clear when memory tab notifies it has been seen.
    function onSeen() { setHasNew(false); }
    window.addEventListener("gully:memory-seen", onSeen);
    return () => { alive = false; window.removeEventListener("gully:memory-seen", onSeen); };
  }, []);
  return hasNew;
}
